import EventEmitter from "events"
import {IPFS} from "ipfs-core"
import OrbitDB from "orbit-db"
import {useCallback, useContext, useEffect, useRef, useState} from "react"
import {BackendContext} from "../context/BackendContext"
import {notifyUpdate} from "../functions/ipfs-orbit"
import {RepoDB} from "../models/RepoDB.model"

export const useFetchRepoDB = (orbitId?: string, dbName?: string) => {
  const {orbit, ipfs} = useContext(BackendContext)
  const [repoDB, setRepoDB] = useState<RepoDB>()
  const [repoReplCnt, setRepoReplCnt] = useState(0)
  const replicatedEvent = useRef<EventEmitter>()

  const fetchRepoDB = useCallback(async (
    ipfs: IPFS,
    orbit: OrbitDB,
    orbitId: string,
    dbName: string
  ) => {
    const address = `/orbitdb/${orbitId}/${dbName}`
    await notifyUpdate(ipfs, address)
    const db = await orbit.keyvalue(address) as RepoDB
    await db.load()
    replicatedEvent.current = db.events.on("replicated", () => {
      setRepoReplCnt(prevState => prevState + 1)
    })
    setRepoDB(db)
  }, [])

  useEffect(() => {
    if (!orbit || !ipfs || !orbitId || !dbName) {
      return
    }
    fetchRepoDB(ipfs, orbit, orbitId, dbName).then()
  }, [orbit, ipfs, orbitId, dbName])

  useEffect(() => {
    return () => {
      replicatedEvent.current?.removeAllListeners()
    }
  }, [])

  useEffect(() => {
    if (!repoDB) {
      return
    }

    return () => {
      console.log(`closing ${repoDB.address.toString()}`)
      repoDB?.close().then(_ => {
        console.log(`closed ${repoDB.address.toString()}`)
      })
    }
  }, [repoDB])

  return {
    repoDB,
    repoReplCnt,
    setRepoReplCnt
  }
}
